import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect, DispatchProp } from "react-redux";
import { isPhone } from "@cadmakers-ui/core";
import { appPaths, IAppState, ErrorDisplay, LoadingDisplay } from "../../../Common";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import { Application, ActiveAppName, SubscriptionState, appService } from "../..";
import { SearchContext } from "../../../Layout/Models/SearchContext";
import { SearchContextType } from "../../../Layout/Constants/LayoutEnums";
import "../../Styles/ApplicationFeedbackContainer.scss";
import SubscribeToAppButtonContainer from "../Common/SubscribeToAppButton/SubscribeToAppButtonContainer";

type TParams = {
  id: string;
};

interface StateProps {
  appSubState: Record<string, SubscriptionState>;
  activeApp?: Application;
}

const mapStateToProps = (state: IAppState): StateProps => ({
  appSubState: appService.getApplicationSubStatesFromAppState(state),
  activeApp: state.app.activeApp
});

const CLASSNAME_PREFIX = "ApplicationFeedbackContainer__";
const FEATURE_REQUEST = [FeedbackCategory.FeatureRequest];
const BUG_REPORT = [FeedbackCategory.BugReport];
const RESOURCE_REQUEST = [FeedbackCategory.ResourceRequest];

const ApplicationFeedbackContainer: React.FC<RouteComponentProps<TParams> & StateProps> = props => {
  const context: SearchContext = {
    type: SearchContextType.App,
    itemId: props.match.params.id
  };

  return (
    <div>
      <div className={`${CLASSNAME_PREFIX}heading`}>
        <span className={`${CLASSNAME_PREFIX}heading-title`}>
          {!isPhone && (
            <h2>
              <ActiveAppName /> Feedback
            </h2>
          )}
        </span>
        {!isPhone && (
          <span className={`${CLASSNAME_PREFIX}heading-subscribe`}>
            {props.appSubState[props.match.params.id] === SubscriptionState.Active ? (
              <SubscribeToAppButtonContainer appId={props.match.params.id} />
            ) : null}
          </span>
        )}
      </div>
      <div>
        <h3>
          Recent Feature Requests{" "}
          <Link to={appPaths.app.featureRequests.replace(":id", props.match.params.id)}>
            (See All)
          </Link>
        </h3>
        <FeedbackListContainer
          listId={`APP_RECENT_FEATURE_REQUEST_LIST_${props.match.params.id}`}
          context={context}
          maxNumToGet={5}
          maxPerPage={5}
          paging={false}
          enableSearch
          seeMoreLink={{
            url: appPaths.app.featureRequests.replace(":id", props.match.params.id),
            text: "See All..."
          }}
          sort={FeedbackSortOption.DateCreated}
          isAscending={false}
          reorderable={false}
          virtualizeDisabled
          selectedCategories={FEATURE_REQUEST}
        />
        <br />
        <h3>
          Recent Bug Reports{" "}
          <Link to={appPaths.app.bugReports.replace(":id", props.match.params.id)}>(See All)</Link>
        </h3>
        <FeedbackListContainer
          listId={`APP_RECENT_BUG_REPORT_LIST_${props.match.params.id}`}
          context={context}
          maxNumToGet={5}
          maxPerPage={5}
          paging={false}
          enableSearch
          seeMoreLink={{
            url: appPaths.app.bugReports.replace(":id", props.match.params.id),
            text: "See All..."
          }}
          sort={FeedbackSortOption.DateCreated}
          isAscending={false}
          reorderable={false}
          virtualizeDisabled
          selectedCategories={BUG_REPORT}
        />
        {props.activeApp?.allowResourceRequest && (
          <>
            <br />
            <h3>
              Recent Resource Requests{" "}
              <Link to={appPaths.app.resourceRequests.replace(":id", props.match.params.id)}>
                (See All)
              </Link>
            </h3>
            <FeedbackListContainer
              listId={`APP_RECENT_RESOURCE_REQUEST_LIST_${props.match.params.id}`}
              context={context}
              maxNumToGet={5}
              maxPerPage={5}
              paging={false}
              enableSearch
              seeMoreLink={{
                url: appPaths.app.resourceRequests.replace(":id", props.match.params.id),
                text: "See All..."
              }}
              sort={FeedbackSortOption.DateCreated}
              isAscending={false}
              reorderable={false}
              virtualizeDisabled
              selectedCategories={RESOURCE_REQUEST}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ApplicationFeedbackContainer);
